import { createSelector } from 'reselect';

export const selectWorkspace = state => {
  const workspaces = state?.workspace?.workspaces;

  if (!workspaces?.length) {
    return undefined;
  }

  return workspaces.find(workspace => workspace.isSelected);
};

export const selectWorkspaceId = createSelector(
  selectWorkspace,
  workspace => workspace?.id
);
